export default __webpack_public_path__ + "static/media/logo_cte_tutorial.0047ca60.png";